import React, { useState, useEffect } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from '@/components/ui/button';
import { ChevronDown, Download, FileText, FileTextIcon } from 'lucide-react'
import { TbFileTypeJsx } from "react-icons/tb";
import { PiFilePdf } from "react-icons/pi";
import Footer from './Footer';
import { ModeToggle } from '@/components/mode-toggle';
import Navigationbar from './utils/Navigationbar';
import { NavLink } from 'react-router-dom';
import Craft from './Craft';
import Contact from './Contact';
import { Highlighter } from '@/components/ui/highlighter';

export default function MinimalHome() {

  const generateRandomString = (length) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  };

  // Generate 300 string acak
  // const randomParagraphs = Array.from({ length: 2000 }, (_, i) => (
  //   <p key={i} className="text-sm hover:opacity-80">
  //     {generateRandomString(1)} {/* ganti 8 kalau mau string lebih panjang */}
  //   </p>
  // ));

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // Change the breakpoint as per your needs
      };
  
      window.addEventListener('resize', handleResize);
  
      // Cleanup function to remove the event listener
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

  return (
    <div className='relative'>
        <section className='container max-w-md mx-auto pt-12 lg:pt-32 px-4 px-6 lg:px-0'>
            <div className='relative z-50 w-full'>
                <div className='mb-4 flex items-center justify-between gap-4'>
                    <NavLink to='/'>
                        <img src='/unaascii-xsm.png' className='w-12 block dark:hidden rounded-full' />
                        <img src='/unaascii-xsm-white.png' className='w-12 hidden dark:block rounded-full' />
                    </NavLink>
                    <Navigationbar />
                </div>
                <div className='flex flex-col gap-6 mb-6'>
                    <div className='flex flex-col items-start justify-center mb-8'>
                        <p>Dinivan Nendra</p>
                        <p className='opacity-60 opacity-60 text-sm font-light'>UIX Designer & Engineer</p>
                    </div>
                    <div className='flex flex-col items-start justify-start gap-4'>
                        <p> <Highlighter action="highlight" color="#FF9800" delay={500}>Freelance software protyper</Highlighter> <br />  I turn complicated tech into clean, intuitive interfaces — then obsess over the details that make them feel right. <br /> Currently open for projects.</p>
                        {/* <p className='opacity-50'>I care a lot about how things feel. Not just how they look, but how they work when someone's actually using them.</p> */}
                    </div>
                </div>

                

                {/* <div className='flex items-center w-full justify-between gap-3 py-12'>
                    <Footer />
                    <ModeToggle />
                </div> */}
            </div>
        </section>
        <Craft />
        <Contact />
         {isMobile ? 
         <div/>
         : <div className='absolute top-0 opacity-[.07] dark:opacity-[.05] min-w-screen flex flex-wrap gap-2'>
            {/* {randomParagraphs} */}
        </div>
        }
        
    </div>
  )
}
